import { Box, BoxProps, Center, Link, LinkProps, Text } from "@chakra-ui/react";
import { ResourcesSectionResource } from "lib/gcms";
import Image from "next/image";

export interface ResourcePreviewProps extends ResourcesSectionResource {
  rootProps?: BoxProps;
  onClick?: LinkProps["onClick"];
}

export const ResourcePreview = (props: ResourcePreviewProps) => {
  const { title, subtitle, bg, color, slug, thumbnail, rootProps } = props;
  return (
    <Box position="relative" key={slug} overflow="hidden" {...rootProps} p="6">
      <Link
        onClick={props?.onClick}
        _hover={{
          textDecoration: "none",
          h4: {
            textDecoration: "underline",
          },
          ".resource-preview-thumbnail .overlay": {
            opacity: 0.75,
          },
        }}
      >
        <Box
          w="60%"
          mx="auto"
          minW="150px"
          pos="relative"
          className="resource-preview-thumbnail"
        >
          <Image
            {...thumbnail?.img}
            src={thumbnail?.img?.url}
            objectFit={"contain"}
            alt={new URL(thumbnail?.img?.url).pathname.slice(1)}
            placeholder={
              typeof thumbnail?.img?.blurDataURL === "string"
                ? "blur"
                : undefined
            }
            blurDataURL={
              typeof thumbnail?.img.blurDataURL === "string"
                ? thumbnail?.img.blurDataURL
                : undefined
            }
          />
          <Center
            pos="absolute"
            top="4"
            left="4"
            right="4"
            bottom="4"
            rounded="lg"
            color={color || "text"}
            opacity={0}
            bg={bg || "white"}
            className="overlay"
          >
            <Text fontSize="xl" fontWeight="bold" textAlign="center">
              See Details
            </Text>
          </Center>
        </Box>

        <Box width="full" textAlign="center">
          <Text
            as="h4"
            mt="3"
            fontSize="2xl"
            fontFamily="numerical"
            fontWeight="bold"
          >
            {title}
          </Text>
          <Text fontSize="md">{subtitle}</Text>
        </Box>
      </Link>
    </Box>
  );
};
